const dddGenerationNotifications: Record<string, string> = {
  'DDD file entered is a vehicle unit gen 1': 'Gen 1',
  'DDD file entered is a vehicle unit gen2v1': 'Gen 2 V1',
  'DDD file entered is a vehicle unit gen2v2': 'Gen 2 V2',
  'DDD file entered is a driver card file': 'Driver card'
};

const getDddGeneration = (notifications?: string[]) => {
  if (!notifications) {
    return '-';
  }

  const generationNotification = notifications.find(notification => (
    Object.prototype.hasOwnProperty.call(dddGenerationNotifications, notification.trim())
  ));

  return generationNotification
    ? dddGenerationNotifications[generationNotification.trim()]
    : '-';
};

export default getDddGeneration;
